"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeOfCollectionPropertyOption = exports.isTypeOfCollectionProperty = exports.typeOfCollectionPropertyDefinition = void 0;
const typeOfCollectionPropertyOptions = ['abstract', 'discipline-pseudogroup'];
exports.typeOfCollectionPropertyDefinition = {
    view: { label: 'Type of collection' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: typeOfCollectionPropertyOptions,
        },
    ],
    type: 'select',
    multiple: false,
    name: 'type-of-collection',
};
const isTypeOfCollectionProperty = (prop) => {
    return prop.name === exports.typeOfCollectionPropertyDefinition.name;
};
exports.isTypeOfCollectionProperty = isTypeOfCollectionProperty;
const isTypeOfCollectionPropertyOption = (option) => {
    return typeOfCollectionPropertyOptions.includes(option);
};
exports.isTypeOfCollectionPropertyOption = isTypeOfCollectionPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS1vZi1jb2xsZWN0aW9uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdHlwZS1vZi1jb2xsZWN0aW9uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQU0sK0JBQStCLEdBQUcsQ0FBQyxVQUFVLEVBQUUsd0JBQXdCLENBQVUsQ0FBQTtBQUUxRSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxvQkFBb0IsRUFBRTtJQUNyQyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLCtCQUErQjtTQUMxQztLQUNGO0lBQ0QsSUFBSSxFQUFFLFFBQVE7SUFDZCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxvQkFBb0I7Q0FDSyxDQUFBO0FBSTFCLE1BQU0sMEJBQTBCLEdBQUcsQ0FBQyxJQUFrQixFQUFvQyxFQUFFO0lBQ2pHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywwQ0FBa0MsQ0FBQyxJQUFJLENBQUE7QUFDOUQsQ0FBQyxDQUFBO0FBRlksUUFBQSwwQkFBMEIsOEJBRXRDO0FBSU0sTUFBTSxnQ0FBZ0MsR0FBRyxDQUFDLE1BQWMsRUFBNEMsRUFBRTtJQUMzRyxPQUFRLCtCQUFxRCxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUNoRixDQUFDLENBQUE7QUFGWSxRQUFBLGdDQUFnQyxvQ0FFNUMifQ==